const ContactRelationshipDefiner = (val: any) => {
  let definedData = null
  switch (val) {
    case 'Parent':
      definedData = { label: 'Orang Tua', value: 'Parent' }
      break
    case 'Partner':
      definedData = { label: 'Pasangan', value: 'Spouse' }
      break
    case 'Sibling':
      definedData = { label: 'Saudara', value: 'Sibling' }
      break
    case 'Child':
      definedData = { label: 'Anak', value: 'Child' }
      break
    case 'Other':
      definedData = { label: 'Lain-lain', value: 'Other' }
      break
    default:
      break
  }
  return definedData
}

export default ContactRelationshipDefiner
